import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupByPlayer } from './gameSlice';
import Cookies from "js-cookie";
import { getUserColor } from '../../utils/index';
import api from '../../api';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useDisableBrowserBack from "../hooks/useDisableBrowserBack";
import useReadCookies from "../hooks/useReadCookies";
import StarFX from './questionContainer/subcomponents/starFX';

function FindGroup() {
  useDisableBrowserBack();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const players = useSelector((state) => state.game.players);
  const playerCount = useSelector((state) => state.game.playerCount);
  const joinedPlayerCount = useSelector((state) => state.game.joinedPlayerCount);
  const confirmedPlayerCount = useSelector((state) => state.game.confirmedPlayerCount);
  const groupName = useSelector((state) => state.game.groupName);

  let { cookiePlayerId, cookieGameId } = useReadCookies();

  const otherPlayerName = players.reduce((filtered, player) => {
    if (player.secret !== cookiePlayerId) {
      filtered.push(player.name);
    }
    return filtered;
  }, []);

  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    dispatch(getGroupByPlayer(cookiePlayerId));

    // polling for group status every 5 seconds until group is confirmed  
    const interval = setInterval(() => {
      dispatch(getGroupByPlayer(cookiePlayerId));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  //check all confirmations
  useEffect(() => {
    if (confirmedPlayerCount != 0 && playerCount === confirmedPlayerCount) {
      setTimeout(() => {
        navigate(`/app/game/avatar/${cookieGameId}/${cookiePlayerId}${window.location.search}`);
      }, 1000);
    }
  }, [confirmedPlayerCount]);

  const confirmGroupHandler = () => {
    setIsSubmitting(true);
    api.confirmGroup(cookiePlayerId).then(response => {
      if (response.status === 200) {
        dispatch(getGroupByPlayer(cookiePlayerId));
      }
    });
  };

  return (
    <div className="mobileContainer blackNights find-group-screen">
      <div className="find-group-wrapper">
        <div className='title-wrapper'>
          <div className='title'>
            <h3>{t("student.find_group.title")}</h3>
          </div>
          <div className='ornament-left'></div>
          <div className='ornament-right'></div>
          <div className='ornament-rays'>
            <StarFX/>
          </div>
        </div>
        <div className='group-card frameGoldOpen'>
        <ul className='group-card-list'>
          {players && players.map((player, index) =>
            <li className={`player-row ${(player.status === 'joined' || player.status === 'confirmed') ? 'player-active' : ''} 
            ${(player.secret === cookiePlayerId) ? 'player-current' : ''}`} key={player.id}>
              <div className={
                `player-badge 
                `}>
                <div className='badge-ring-coloring' style={{ borderColor: getUserColor(player.secret) }}></div>
                <div className='badge-ring ring-idle-indicator' style={{ animationDelay: index + 's' }}></div>
                <div className='badge-ring ring-idle-inner'></div>
                <div className='badge-ring ring-idle-outer ring-motion'></div>
                <div className={`badge-ring ring-active-${Math.min(index, 2) + 1}`}></div>
                <div className='badge-ring ring-active-current ring-motion'></div>
                <div className='player-indicator'>
                  <p className='player-indicator-label'>{t("student.find_group.player")}&nbsp;&nbsp;{index + 1}</p>
                  <svg viewBox="0 0 73.07 33.98">
                    <defs>
                      <path id="player-indicator-path" d="M63.24 1.16c-.08-.03-1.63-.13-2.84-.12-1.71.02-3.38.04-4.85.1H29.89c-.26-.06-.51-.11-.73-.15-.03.03.02.09.06.15h-3.25s.02 0 .02-.01c-1.03 0-1.86.04-2.61-.08-.5.03-.71.07-.79.1h-1.56c.08-.16.63-.37.05-.54C23.18.4 10.92.14 10.8.25 8.81.35 9.03.14 8.62.01 7.15.13 7.31.43 6.41.65 5.65.59 5.05.55 4.55.52l-.7-.03c-.26 0-.54-.02-.8-.01-.52.02-1.02.19-1.49.55-.46.36-.91.94-1.03 1.82.1-.06.2-.1.31-.15-.03.14-.04.28-.05.41-.01.23-.02.43-.03.61v.45c.01.28.04.53.07.78.06.51.11 1.06.03 1.99C.8 7.05.4 7.3.52 9.01L.19 7.66C.2 9.02.3 11.02.02 10.31c.34 2.38.21 6.54.4 9.51l-.26-.2c.16.77.15 2.18.16 3.56v1.61c0 .24.01.47.06.68.15.87.69 1.44 1.09 1.66.06.09.12.19.19.27.64.38 1.39.4 2.1.32l1.54-.17c1.38.03.91.42 1.03.31 3.04-.07 5.42-.09 7.37.04.49-.34 3.68-.44 6.22-.48 12.24.21 25.38-.11 36.76-.51.51 0 1.09-.04 1.7-.1h4.48c5.58 0 10.22 7.17 10.22 7.17V8.18s-1.95-6.8-9.84-7.02Z" />
                      <clipPath id="player-indicator-clip-path">
                        <use href="#player-indicator-path"/>
                      </clipPath>
                    </defs>
                    <g >
                      <use clipPath="url(#player-indicator-clip-path)" href="#player-indicator-path" style={{fill: player.name ? getUserColor(player.secret) : '#333333', strokeWidth: 4, stroke: '#ffffff', strokeOpacity: player.name ? .3 : .1}} data-name="Layer 1"/>
                    </g>
                  </svg>
                </div>
              </div>
              <div className='player-name'>{player.name ? player.name : t("student.find_group.waiting")}</div>
              <div className={`player-status ${player.status === 'confirmed' ? 'active' : ''}`}></div>
            </li>
          )}
        </ul>
        </div>
        <div className={`frameSimple blackNightsTheme animateIn information`}>
          {joinedPlayerCount != playerCount && <p>{t("student.find_group.help")}</p>}
          {playerCount === 3 && joinedPlayerCount == playerCount && <p>{t("student.find_group.help_2", otherPlayerName)}</p>}
          {playerCount === 4 && joinedPlayerCount == playerCount && <p>{t("student.find_group.help_2_extra_layer", otherPlayerName)}</p>}
        </div>
        {(joinedPlayerCount === playerCount) &&
          <div className="navigationWrapper">
            <div className='navigationDrawer variant7 flexible enableInAnimation'>
              <p className={`navigationDrawerHint ${isSubmitting ? 'disabled' : ''}`}>{t("student.find_group.found_message")}</p>
              <button className={`submitButton enableInAnimation ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting} onClick={confirmGroupHandler}>
                <span className='caption'>{t("student.find_group.found_button")}</span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

/*

<div className="mobile-container find-group-screen">
      <div className="content-wrapper">
        <h3 ref={e => {titleRef = e}}>{t("student.find_group.title")}</h3>
        <div className="group-card" ref={e => {groupRef = e}}>
          <p className="group-name">{groupName}</p>
          <ul>
            {players && players.map((player, index) =>
              (player.status === 'joined' || player.status ==='confirmed') &&
              <li key={player.id}>
                <div className="player-wrapper">
                  
                  <div className="player-info">
                    <p className="player-id" style={{ color: getUserColor(player.secret)}}>{t("student.find_group.player")} {++index}</p>
                    <div className="player-name">
                      <p>{player.name}</p>
                      {player.status === 'confirmed' && (
                         <div className="check">
                         <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M21.75 3.79688C22.5 3.04688 22.5 1.875 21.75 1.125C21 0.421875 19.8281 0.421875 19.125 1.125L8.4375 11.8125L3.75 7.125C3 6.42188 1.82812 6.42188 1.125 7.125C0.375 7.875 0.375 9.04688 1.125 9.79688L7.125 15.7969C7.45312 16.1719 7.96875 16.3594 8.4375 16.3594C8.90625 16.3594 9.375 16.1719 9.75 15.7969L21.75 3.79688Z" fill="white"/>
                         </svg>
                       </div>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            )}
            {players && players.map((player) =>
              (player.status !== 'joined' && player.status !=='confirmed') &&
              <li key={player.id}>
                <div className="player-wrapper waiting">
                  <div className="avatar">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.75 0.75C20.9062 0.75 20.25 1.45312 20.25 2.25V4.40625C18.1406 2.10938 15.1406 0.75 12 0.75C7.125 0.75 2.85938 3.84375 1.3125 8.4375C0.984375 9.42188 1.5 10.4531 2.48438 10.7812C2.67188 10.875 2.90625 10.875 3.09375 10.875C3.89062 10.875 4.59375 10.4062 4.875 9.60938C5.90625 6.5625 8.76562 4.5 12 4.5C14.3438 4.5 16.5469 5.67188 17.9531 7.5H17.1094V7.54688H15.7031C14.9062 7.54688 14.25 8.20312 14.25 9C14.25 9.84375 14.9062 10.5 15.7031 10.5H21.75C22.125 10.5 22.5 10.3594 22.7812 10.0781C23.0625 9.79688 23.25 9.42188 23.25 9.04688V2.25C23.25 1.45312 22.5469 0.75 21.75 0.75ZM21.4688 13.2656C20.4844 12.8906 19.4062 13.4531 19.0781 14.4375C18.0469 17.4844 15.1875 19.5 12 19.5C9.60938 19.5 7.40625 18.375 6 16.5H6.84375H8.25C9.04688 16.5 9.75 15.8438 9.75 15C9.75 14.2031 9.04688 13.5 8.25 13.5H2.20312C1.82812 13.5 1.45312 13.6875 1.17188 13.9688C0.890625 14.25 0.75 14.625 0.75 15V21.7969C0.75 22.5938 1.40625 23.25 2.20312 23.25C3.04688 23.25 3.70312 22.5938 3.70312 21.7969V19.6406C5.8125 21.9375 8.8125 23.25 12 23.25C16.8281 23.25 21.0938 20.2031 22.6406 15.6094C22.9688 14.625 22.4531 13.5938 21.4688 13.2656Z" fill="#40444B"/>
                  </svg>
                  </div>
                  <div className="player-info">
                    <p>{t("student.find_group.waiting")}</p>
                  </div>
                </div>
              </li>
            )}
          </ul>
        </div>
       <div className="lion" ref={e => {lionRef = e}}>
          <img src="/images/lion.png" width={218} height={216} />
       </div>
       <div className="help" ref={e => {helpRef = e}}>
        {joinedPlayerCount != playerCount && <p>{t("student.find_group.help")}</p>}
        {playerCount === 3 && joinedPlayerCount == playerCount && <p>{t("student.find_group.help_2", otherPlayerName)}</p>}
        {playerCount === 4 && joinedPlayerCount == playerCount && <p>{t("student.find_group.help_2_extra_layer", otherPlayerName)}</p>}
       </div>
      </div>
      <div className="control-panel" ref={e => {controlbarRef = e}}>
        <a className="back visibility-hidden" href="">
          <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 1.5L3 10.5L12 19.5" stroke="white" strokeWidth="4"/>
          </svg>
        </a>
        <button type="submit" className={`continue-button ${joinedPlayerCount != playerCount || isSubmitting ? 'invalid' : ''}`}  disabled={joinedPlayerCount != playerCount || isSubmitting } onClick={confirmGroupHandler}>
          <div className="label">{t("student.find_group.found_button")}</div>
          <div className="arrow">
              <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5L11 10.5L2 19.5" stroke={`${ joinedPlayerCount != playerCount || isSubmitting ? '#183060': 'white'}`} strokeWidth="4"/>
              </svg>
          </div>
        </button>
      </div>
    </div>

*/


export default FindGroup;